import { z } from 'zod';
import { PropertyCarouselSelectorTileProps } from '../subcomponents/PropertyCarouselSelector';
import { mapPropertyStatusToBadge } from './mapPropertyStatusToBadge';
import { createImageUrl } from './createImageUrl';
import { propertySelectorTileComponentSchema } from '../hooks/uiComponentsSchemas';
export const mapUIMessagePropertySelectorTileToProps = (
  propertySelectorTile: z.infer<typeof propertySelectorTileComponentSchema>,
): PropertyCarouselSelectorTileProps['property'] => {
  const { propertyId, address, imageUrl, attributes, price, propertyStatus } = propertySelectorTile;

  return {
    propertyId,
    title: price ?? '',
    image: imageUrl ? createImageUrl(address, imageUrl) : null,
    badge: propertyStatus
      ? mapPropertyStatusToBadge(propertyStatus)
      : {
          text: 'Off market',
          variant: 'grey',
        },
    address,
    features: attributes.map((attribute) => ({
      iconName:
        attribute.attributeType === 'bedrooms'
          ? 'BedLg'
          : attribute.attributeType === 'bathrooms'
            ? 'BathLg'
            : 'CarportLg',
      title: attribute.attributeType,
      valueWithUnit: attribute.value,
    })),
  };
};
